import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
var DockDirection = function DockDirection(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('control-dock-direction' + (props.disabled ? ' disabled' : '')),
    onMouseLeave: !props.disabled && props.onMouseLeave ? props.onMouseLeave : null,
    onMouseEnter: !props.disabled && props.onMouseEnter ? props.onMouseEnter.bind(null, props.value) : null
  });
};
DockDirection.displayName = displayNames.DOCK_DIRECTION;
DockDirection.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
DockDirection.defaultProps = {
  disabled: false
};
export default compose(DockDirection);